module.exports = __webpack_public_path__ + "static/media/sylvester_small.1bda0bc9.jpg";